import { useState, useEffect } from 'react';
import './MainPage.scss';
import cn from 'classnames';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import { useNavigate } from 'react-router-dom';
import Image1 from '../../assets/Image1.jpg';
import Adv1 from '../../assets/adv1.jpg';
import Adv2 from '../../assets/adv2.jpg';
import Adv9 from '../../assets/adv9.jpg';
import Adv7 from '../../assets/adv7.jpg';
import Point1 from '../../assets/point1.png';
import Point7 from '../../assets/point7.png';
import Clients from '../../components/Clients';
import Reviews from '../../components/Reviews';
import Background from '../../assets/background.jpg';
import Form from '../../components/Form';

const MainPage = () => {
  const navigate = useNavigate();
  const [isFormOpen, setFormOpen] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [window.location.pathname]);

  return (
    <div className='page'>
      <Header onFormClick={() => setFormOpen(true)} />
      <div className='firstScreen'>
        <div className='firstScreenContent'>
          <span className='firstScreenTitle'>
            Hire the Right candidates who <span>advance</span>
          </span>
          <span className='firstScreenText'>
            NextDeavor is your staffing partner for building high impact teams that grow with your company. We help you find the
            right talent, fast, so you can focus on what matters.
          </span>
          <span className='firstScreenButton' onClick={() => setFormOpen(true)}>
            Find Your Next Great Hire
            <svg width='28' height='28' viewBox='0 0 28 28' fill='none' xmlns='http://www.w3.org/2000/svg'>
              <path
                d='M14 2.625C11.7502 2.625 9.551 3.29213 7.68039 4.54203C5.80978 5.79193 4.35182 7.56847 3.49088 9.64698C2.62993 11.7255 2.40467 14.0126 2.84357 16.2192C3.28248 18.4257 4.36584 20.4525 5.95667 22.0433C7.54749 23.6342 9.57432 24.7175 11.7809 25.1564C13.9874 25.5953 16.2745 25.3701 18.353 24.5091C20.4315 23.6482 22.2081 22.1902 23.458 20.3196C24.7079 18.449 25.375 16.2498 25.375 14C25.3718 10.9841 24.1724 8.09271 22.0398 5.96018C19.9073 3.82764 17.0159 2.62818 14 2.625ZM18.9941 14.6191L15.4941 18.1191C15.3299 18.2833 15.1072 18.3755 14.875 18.3755C14.6428 18.3755 14.4201 18.2833 14.2559 18.1191C14.0918 17.9549 13.9995 17.7322 13.9995 17.5C13.9995 17.2678 14.0918 17.0451 14.2559 16.8809L16.263 14.875H9.62501C9.39294 14.875 9.17038 14.7828 9.00629 14.6187C8.84219 14.4546 8.75001 14.2321 8.75001 14C8.75001 13.7679 8.84219 13.5454 9.00629 13.3813C9.17038 13.2172 9.39294 13.125 9.62501 13.125H16.263L14.2559 11.1191C14.0918 10.9549 13.9995 10.7322 13.9995 10.5C13.9995 10.2678 14.0918 10.0451 14.2559 9.88094C14.4201 9.71675 14.6428 9.62451 14.875 9.62451C15.1072 9.62451 15.3299 9.71675 15.4941 9.88094L18.9941 13.3809C19.0754 13.4622 19.14 13.5587 19.184 13.6649C19.228 13.7712 19.2507 13.885 19.2507 14C19.2507 14.115 19.228 14.2289 19.184 14.3351C19.14 14.4413 19.0754 14.5378 18.9941 14.6191Z'
                fill='white'
              />
            </svg>
          </span>
        </div>
        <div className='firstScreenImage'>
          <img src={Image1} />
        </div>
      </div>

      <div className='advantages'>
        <div className='advantagesContent'>
          <span className='blockTitle'>
            <span>Human-First</span> Recruiting, Enhanced by <span>AI</span>
          </span>
          <div className='advantage'>
            <span className='advantageDescription'>
              We put <b>people at the center</b> of everything we do. While <b>AI</b>helps us streamline the process, it’s{' '}
              <b>our recruiters’</b> expertise that makes all the difference in <b>finding candidates</b> who align with{' '}
              <b>your team</b> and culture.
            </span>
            <span className='advantageImage'>
              <img src={Adv1} />
            </span>
          </div>
          <div className='advantage'>
            <span className='advantageDescription'>
              Our approach ensures that <b>every candidate</b> we present isn’t just <b>technically skilled</b>, but the right fit
              for your company: a <b>person</b> who will <b>thrive and grow</b> with you. With <b>AI accelerating</b> the search,
              we free up time for what <b>truly matters: building lasting relationships.</b>
            </span>
            <span className='advantageImage'>
              <img src={Adv9} />
            </span>
          </div>
          <div className='advantage'>
            <span className='advantageDescription'>
              That means no more <b>wasting time</b> on <b>lukewarm candidates.</b> Just top talent ready to help you scale
              faster.
            </span>
            <span className='advantageImage'>
              <img src={Adv2} />
            </span>
          </div>
          <span className='contactButton' onClick={() => setFormOpen(true)}>
            Let’s find your next great hire
            <svg width='28' height='28' viewBox='0 0 28 28' fill='none' xmlns='http://www.w3.org/2000/svg'>
              <path
                d='M14 2.625C11.7502 2.625 9.551 3.29213 7.68039 4.54203C5.80978 5.79193 4.35182 7.56847 3.49088 9.64698C2.62993 11.7255 2.40467 14.0126 2.84357 16.2192C3.28248 18.4257 4.36584 20.4525 5.95667 22.0433C7.54749 23.6342 9.57432 24.7175 11.7809 25.1564C13.9874 25.5953 16.2745 25.3701 18.353 24.5091C20.4315 23.6482 22.2081 22.1902 23.458 20.3196C24.7079 18.449 25.375 16.2498 25.375 14C25.3718 10.9841 24.1724 8.09271 22.0398 5.96018C19.9073 3.82764 17.0159 2.62818 14 2.625ZM18.9941 14.6191L15.4941 18.1191C15.3299 18.2833 15.1072 18.3755 14.875 18.3755C14.6428 18.3755 14.4201 18.2833 14.2559 18.1191C14.0918 17.9549 13.9995 17.7322 13.9995 17.5C13.9995 17.2678 14.0918 17.0451 14.2559 16.8809L16.263 14.875H9.62501C9.39294 14.875 9.17038 14.7828 9.00629 14.6187C8.84219 14.4546 8.75001 14.2321 8.75001 14C8.75001 13.7679 8.84219 13.5454 9.00629 13.3813C9.17038 13.2172 9.39294 13.125 9.62501 13.125H16.263L14.2559 11.1191C14.0918 10.9549 13.9995 10.7322 13.9995 10.5C13.9995 10.2678 14.0918 10.0451 14.2559 9.88094C14.4201 9.71675 14.6428 9.62451 14.875 9.62451C15.1072 9.62451 15.3299 9.71675 15.4941 9.88094L18.9941 13.3809C19.0754 13.4622 19.14 13.5587 19.184 13.6649C19.228 13.7712 19.2507 13.885 19.2507 14C19.2507 14.115 19.228 14.2289 19.184 14.3351C19.14 14.4413 19.0754 14.5378 18.9941 14.6191Z'
                fill='white'
              />
            </svg>
          </span>
        </div>
      </div>
      <div className='info'>
        <div className='advantage'>
          <div className='advantageInfo'>
            <span className='advantageTitle'>Humans at the Heart of Every Hire</span>
            <span className='advantageText'>
              We believe in human first recruiting. Our AI powered process accelerates the search, but it’s the human connections
              that drive success. From tech to marketing, engineering to finance, our team of expert recruiters works closely with
              you to ensure every hire aligns with your culture and long-term goals.
            </span>
          </div>
          <span className='advantageImage'>
            <img src={Adv7} />
          </span>
        </div>
      </div>
      <div className='points'>
        <div className='point'>
          <span className='pointIcon'>
            <img src={Point1} />
          </span>
          <span className='pointTitle'>Human Connections, Powered by AI Technology</span>
          <span className='pointText'>
            Our <b>AI technology</b> supports our <b>human-first approach</b> by refining and accelerating the recruitment
            process. But at
            <b>NextDeavor</b>, it’s our <b>recruiters</b> who make the <b>real impact,</b> using technology to enhance their
            ability to <b>connect</b> with candidates, ensuring they are the <b>right fit</b> for your <b>team.</b>
          </span>
        </div>
        <div className='point'>
          <span className='pointIcon'>
            <img src={Point7} />
          </span>
          <span className='pointTitle'>People Matter Most</span>
          <span className='pointText'>
            We’re <b>committed</b> to building teams that are as <b>unique and dynamic</b> as the world around us. It’s not just a
            trend, it’s a<b>core value.</b> If you're looking for a <b>partner</b> who <b>values individuality</b> and ensures{' '}
            <b>every hire</b> is a <b>great fit</b> for your team, you’ve found the <b>right</b> place.
          </span>
        </div>
      </div>

      <div className='clientsSection'>
        <span className='blockTitle'>Recent Clients Include…</span>
        <Clients />
      </div>

      <Reviews />

      <div className='spacer' />

      <div className='adBlock'>
        <span className='adBlockBackgroung'>
          <img src={Background} />
        </span>
        <div className='adBlockDetails'>
          <span className='adBlockTitle'>Ready for a Human First, Smarter Recruiting Experience?</span>
          <span className='adBlockText'>
            Let’s connect and build a team that makes an impact. Book a quick 10-minute discovery call to get started.
          </span>
        </div>
        <span className='adBlockButton' onClick={() => setFormOpen(true)}>
          Find Next Great Hire
          <svg width='28' height='28' viewBox='0 0 28 28'>
            <path
              d='M14 2.625C11.7502 2.625 9.551 3.29213 7.68039 4.54203C5.80978 5.79193 4.35182 7.56847 3.49088 9.64698C2.62993 11.7255 2.40467 14.0126 2.84357 16.2192C3.28248 18.4257 4.36584 20.4525 5.95667 22.0433C7.54749 23.6342 9.57432 24.7175 11.7809 25.1564C13.9874 25.5953 16.2745 25.3701 18.353 24.5091C20.4315 23.6482 22.2081 22.1902 23.458 20.3196C24.7079 18.449 25.375 16.2498 25.375 14C25.3718 10.9841 24.1724 8.09271 22.0398 5.96018C19.9073 3.82764 17.0159 2.62818 14 2.625ZM18.9941 14.6191L15.4941 18.1191C15.3299 18.2833 15.1072 18.3755 14.875 18.3755C14.6428 18.3755 14.4201 18.2833 14.2559 18.1191C14.0918 17.9549 13.9995 17.7322 13.9995 17.5C13.9995 17.2678 14.0918 17.0451 14.2559 16.8809L16.263 14.875H9.62501C9.39294 14.875 9.17038 14.7828 9.00629 14.6187C8.84219 14.4546 8.75001 14.2321 8.75001 14C8.75001 13.7679 8.84219 13.5454 9.00629 13.3813C9.17038 13.2172 9.39294 13.125 9.62501 13.125H16.263L14.2559 11.1191C14.0918 10.9549 13.9995 10.7322 13.9995 10.5C13.9995 10.2678 14.0918 10.0451 14.2559 9.88094C14.4201 9.71675 14.6428 9.62451 14.875 9.62451C15.1072 9.62451 15.3299 9.71675 15.4941 9.88094L18.9941 13.3809C19.0754 13.4622 19.14 13.5587 19.184 13.6649C19.228 13.7712 19.2507 13.885 19.2507 14C19.2507 14.115 19.228 14.2289 19.184 14.3351C19.14 14.4413 19.0754 14.5378 18.9941 14.6191Z'
              fill='white'
            />
          </svg>
        </span>
      </div>
      <Footer />
      {isFormOpen && <Form onClose={() => setFormOpen(false)} />}
    </div>
  );
};

export default MainPage;
